import { render, staticRenderFns } from "./MarketingWhatsappHeader.vue?vue&type=template&id=025bc703&scoped=true"
import script from "./MarketingWhatsappHeader.vue?vue&type=script&lang=js"
export * from "./MarketingWhatsappHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bc703",
  null
  
)

export default component.exports